import {
  Stepper,
  StepperDivider,
  StepperHighlight,
  StepperItem,
} from "@babackapp/customer-ui/components/stepper";
import {
  InfoIcon,
  SettingsIcon,
  ShoppingCartIcon,
  WalletIcon,
} from "lucide-react";
import { useLocation } from "react-router-dom";

export function LineItemStepper() {
  const { pathname } = useLocation();
  const step = pathname.split("/").pop();

  const stepState = (match: string, after: string[]) =>
    step === match ? "present" : after.includes(step!) ? "past" : "future";

  return (
    <div className="flex gap-2 items-center -ml-0">
      <Stepper>
        <StepperItem
          state={stepState("line-item", ["reason", "resolution", "resolution-options"])}
          style={{ cursor: "default" }}
        >
          {step === "line-item" && <StepperHighlight />}
          <ShoppingCartIcon />
          <span>Article</span>
        </StepperItem>
        <StepperDivider />
        <StepperItem
          state={stepState("reason", ["resolution", "resolution-options"])}
          style={{ cursor: "default" }}
        >
          {step === "reason" && <StepperHighlight />}
          <InfoIcon />
          <span>Raison</span>
        </StepperItem>
        <StepperDivider />
        <StepperItem
          state={stepState("resolution", ["resolution-options"])}
          style={{ cursor: "default" }}
        >
          {step === "resolution" && <StepperHighlight />}
          <WalletIcon />
          <span>Resolution</span>
        </StepperItem>
        <StepperDivider />
        <StepperItem
          state={stepState("resolution-options", [])}
          style={{ cursor: "default" }}
        >
          {step === "resolution-options" && <StepperHighlight />}
          <SettingsIcon />
          <span>Options</span>
        </StepperItem>
      </Stepper>
    </div>
  );
}
